export var JobSubcontractorTimelineLabel;
(function (JobSubcontractorTimelineLabel) {
    JobSubcontractorTimelineLabel["customerContactAttempted"] = "Customer Contact Attempted";
    JobSubcontractorTimelineLabel["jobBillCreated"] = "Job Bill Created";
    JobSubcontractorTimelineLabel["jobBillPaymentMade"] = "Job Bill Payment Made";
    JobSubcontractorTimelineLabel["jobBillUpdated"] = "Job Bill Updated";
    JobSubcontractorTimelineLabel["jobCreated"] = "Job Created";
    JobSubcontractorTimelineLabel["scheduledDate"] = "Scheduled Date";
    JobSubcontractorTimelineLabel["workCompleted"] = "Work Completed";
    JobSubcontractorTimelineLabel["workDetailsReceived"] = "Work Details Received";
    JobSubcontractorTimelineLabel["workStarted"] = "Work Started";
})(JobSubcontractorTimelineLabel || (JobSubcontractorTimelineLabel = {}));
export const jobSubcontractorChronicleLabelMap = {
    appointmentCompleted: JobSubcontractorTimelineLabel.workStarted,
    appointmentScheduled: JobSubcontractorTimelineLabel.scheduledDate,
    cancelled: JobSubcontractorTimelineLabel.workCompleted,
    completed: JobSubcontractorTimelineLabel.workCompleted,
    customerContactAttempted: JobSubcontractorTimelineLabel.customerContactAttempted,
    received: JobSubcontractorTimelineLabel.jobCreated,
    started: JobSubcontractorTimelineLabel.workStarted,
    withdrawn: JobSubcontractorTimelineLabel.workCompleted,
    workDetailsReceived: JobSubcontractorTimelineLabel.workDetailsReceived,
    jobBillCreated: JobSubcontractorTimelineLabel.jobBillCreated,
    jobBillPaymentMade: JobSubcontractorTimelineLabel.jobBillPaymentMade,
    jobBillUpdated: JobSubcontractorTimelineLabel.jobBillUpdated,
};
